export const storageTokenName = '__dbmanagerTokenUser';
export const storageTokenAccess = '__dbmanagerTokenAccess';
export const storageTokenRefresh = '__dbmanagerTokenRefresh';
export const sailsSid = 'sails.sid';

export interface IPermission {
  entity: string,
  actions: string[]
};

export class Permission implements IPermission {
  entity: string;
  actions: string[];

  constructor(
    entity: string,
    actions: string[]
  ) {
    this.entity = entity;
    this.actions = actions;
  }

  hasAction(action: string): boolean {
    return this.actions.indexOf(action) > -1;
  }

  asObject(): any {
    let tmpPermissions: any = { entity: this.entity };
    this.actions.forEach((key, indx) => {
      tmpPermissions[`can_${key}`] = true;
    });
    return tmpPermissions;
  }
};

export interface IAccessPermissions {
  accessPermissions: Permission[]
};


/**
[
    {
        "id": 1,
        "entity": "Company Parameters",
        "action": "update",
        "display_action": "Update"
    },
    {
        "id": 3,
        "entity": "License Agreement",
        "action": "update",
        "display_action": "Update"
    },
    {
        "id": 7,
        "entity": "Manage Roles",
        "action": "update",
        "display_action": "Create, Update & Delete"
    },
    {
        "id": 8,
        "entity": "Manage Users",
        "action": "create",
        "display_action": "Create, Update & Delete"
    },
    {
        "id": 9,
        "entity": "Manage Enquiries",
        "action": "update",
        "display_action": "Complete Enquiry"
    },
    {
        "id": 10,
        "entity": "Manage Enquiry Recipients",
        "action": "update",
        "display_action": "Maintain the Recipient List"
    },
    {
        "id": 11,
        "entity": "Manage Enquiries",
        "action": "view",
        "display_action": "View Enquiries"
    },
    {
        "id": 12,
        "entity": "Manage Help Information",
        "action": "create",
        "display_action": "Create"
    },
    {
        "id": 13,
        "entity": "Manage Help Information",
        "action": "destroy",
        "display_action": "Delete"
    },
    {
        "id": 14,
        "entity": "Manage Help Information",
        "action": "update",
        "display_action": "Update"
    },
    {
        "id": 15,
        "entity": "Manage Companies",
        "action": "create",
        "display_action": "Create"
    },
    {
        "id": 16,
        "entity": "Manage Companies",
        "action": "destroy",
        "display_action": "De-activate / Activate"
    },
    {
        "id": 17,
        "entity": "Manage Companies",
        "action": "update",
        "display_action": "Update"
    },
    {
        "id": 18,
        "entity": "Manage Companies",
        "action": "users",
        "display_action": "Users"
    },
    {
        "id": 19,
        "entity": "Manage Companies",
        "action": "devices",
        "display_action": "Devices"
    },
    {
        "id": 20,
        "entity": "Manage Company Users",
        "action": "create",
        "display_action": "Create"
    },
    {
        "id": 21,
        "entity": "Manage Company Users",
        "action": "destroy",
        "display_action": "De-activate / Activate"
    },
    {
        "id": 22,
        "entity": "Manage Company Users",
        "action": "update",
        "display_action": "Update"
    },
    {
        "id": 23,
        "entity": "Manage Devices",
        "action": "create",
        "display_action": "Create"
    },
    {
        "id": 24,
        "entity": "Manage Devices",
        "action": "destroy",
        "display_action": "De-activate / Activate"
    },
    {
        "id": 25,
        "entity": "Manage Devices",
        "action": "update",
        "display_action": "Update"
    },
    {
        "id": 26,
        "entity": "Manage Sites",
        "action": "create",
        "display_action": "Create"
    },
    {
        "id": 27,
        "entity": "Manage Sites",
        "action": "destroy",
        "display_action": "De-activate / Activate"
    },
    {
        "id": 28,
        "entity": "Manage Sites",
        "action": "update",
        "display_action": "Update"
    },
    {
        "id": 29,
        "entity": "Manage Sites",
        "action": "users",
        "display_action": "Users"
    },
    {
        "id": 30,
        "entity": "Manage Sites",
        "action": "devices",
        "display_action": "Devices"
    },
    {
        "id": 31,
        "entity": "Manage Site Users",
        "action": "create",
        "display_action": "Create"
    },
    {
        "id": 32,
        "entity": "Manage Site Users",
        "action": "destroy",
        "display_action": "De-activate / Activate"
    },
    {
        "id": 33,
        "entity": "Manage Site Users",
        "action": "update",
        "display_action": "Update"
    },
    {
        "id": 34,
        "entity": "Manage Sessions",
        "action": "create",
        "display_action": "Create"
    },
    {
        "id": 35,
        "entity": "Manage Sessions",
        "action": "destroy",
        "display_action": "De-activate / Activate"
    },
    {
        "id": 36,
        "entity": "Manage Sessions",
        "action": "update",
        "display_action": "Update"
    },
    {
        "id": 37,
        "entity": "Manage Sessions",
        "action": "users",
        "display_action": "Users"
    },
    {
        "id": 38,
        "entity": "Manage Sessions",
        "action": "devices",
        "display_action": "Devices"
    },
    {
        "id": 39,
        "entity": "Manage Session Users",
        "action": "create",
        "display_action": "Create"
    },
    {
        "id": 40,
        "entity": "Manage Session Users",
        "action": "destroy",
        "display_action": "De-activate / Activate"
    },
    {
        "id": 41,
        "entity": "Manage Session Users",
        "action": "update",
        "display_action": "Update"
    }
]
 */

/**
 * [
    {
        "id": 13,
        "entity": "Database Updates",
        "action": "Create"
    },
    {
        "id": 14,
        "entity": "Database Updates",
        "action": "Destroy"
    },
    {
        "id": 15,
        "entity": "Database Updates",
        "action": "Update"
    },
    {
        "id": 17,
        "entity": "Permissions",
        "action": "Create"
    },
    {
        "id": 19,
        "entity": "Permissions",
        "action": "Destroy"
    },
    {
        "id": 18,
        "entity": "Permissions",
        "action": "Update"
    },
    {
        "id": 7,
        "entity": "Project",
        "action": "Create"
    },
    {
        "id": 8,
        "entity": "Project",
        "action": "Destroy"
    },
    {
        "id": 9,
        "entity": "Project",
        "action": "Update"
    },
    {
        "id": 4,
        "entity": "Role",
        "action": "Create"
    },
    {
        "id": 5,
        "entity": "Role",
        "action": "Destroy"
    },
    {
        "id": 6,
        "entity": "Role",
        "action": "Update"
    },
    {
        "id": 16,
        "entity": "Settings",
        "action": "Update"
    },
    {
        "id": 1,
        "entity": "User",
        "action": "Create"
    },
    {
        "id": 2,
        "entity": "User",
        "action": "Destroy"
    },
    {
        "id": 3,
        "entity": "User",
        "action": "Update"
    },
    {
        "id": 10,
        "entity": "User Database",
        "action": "Create"
    },
    {
        "id": 11,
        "entity": "User Database",
        "action": "Destroy"
    },
    {
        "id": 12,
        "entity": "User Database",
        "action": "Update"
    }
]
 */
export class AccessPermissions implements IAccessPermissions {
  accessPermissions: Permission[];

  constructor() {
    this.accessPermissions = [
      new Permission("User", [
        "Create",
        "Destroy",
        "Update"
      ]),
      new Permission("Project", [
        "Create", "Update", "Destroy"
      ]),
      new Permission("Database Updates", [
        "Create", "Update", "Destroy"
      ]),
      new Permission("User Database", [
        "Create", "Update", "Destroy"
      ]),
      new Permission("Permissions", [
        "Create",
        "Destroy",
        "Update"
      ]),
      new Permission("Role", [
        "Create",
        "Destroy",
        "Update"
      ]),
      new Permission("Settings", ["Update"]),
      new Permission("Control Params", [
        "Update"
      ]),
      new Permission("Settings", ["Update"]),
      new Permission("Manage Enquiries", ["Update"]),
    ]
  }

  accessPermission(entity: string): Permission | undefined {
    // console.log('accessPermission:entity: ', entity, this.accessPermissions);
    let permission = this.accessPermissions.find(ap => ap.entity === entity);
    return permission;
  };
}

export interface ICanDo {
  entity: string,
  action: string
};

export class CanDo implements ICanDo {
  entity: string;
  action: string;

  constructor(
    entity: string,
    action: string
  ) {
    this.entity = entity;
    this.action = action;
  }
};

export interface IResponseToken {
  meToken: string,
  accessToken: string,
  refreshToken: string,
  longToken?: string
};

export interface IClaimSub {
  userId: number,
  roles: any[],
  admin: boolean,
  superuser: boolean,
  firstName: string,
  lastName: string,
  email: string,
  acceptedTermsVersion: number,
  sessionId?: any,
  researchConsent?: boolean,
  phone?: string
};

export interface IClaimSubAccess {
  permissions: Permission[],
  menuAccess: string[]
};

export interface IClaimSubRefresh {
  userId: number
};

export interface IClaimsUser {
  iat: number;
  exp: number;
  sub?: IClaimSub;
  client_id?: string;
  jti?: string;
  aud?: string[] | string;
  nbf?: number;
  iss?: string;
};

export interface IClaimsAccess {
  iat: number;
  exp: number;
  sub?: IClaimSubAccess;
  client_id?: string;
  jti?: string;
  aud?: string[] | string;
  nbf?: number;
  iss?: string;
};

export interface IClaimsRefresh {
  iat: number;
  exp: number;
  sub?: IClaimSubRefresh;
  client_id?: string;
  jti?: string;
  aud?: string[] | string;
  nbf?: number;
  iss?: string;
};

export class UserClaim implements IClaimsUser {
  static create(args: any) {
    const {
      iat, exp,
      sub, client_id, jti, aud,
      iss, nbf
    } = args;
    return new UserClaim(
      iat, exp,
      sub, client_id, jti, aud,
      iss, nbf
    );
  }
  constructor(
    public iat: number,
    public exp: number,
    public sub?: IClaimSub,
    public client_id?: string,
    public jti?: string,
    public aud?: string[] | string,
    public iss?: string,
    public nbf?: number
  ) { }


  get isExpired(): boolean {
    if (this.exp) {
      return Date.now() / 1000 > this.exp;
      // return moment().unix() > this.exp;
    }    // return Date.now() > claims.exp;
    return true;
  }

  get expiresIn(): number {
    let expirySeconds: number = this.exp - Date.now() / 1000;
    // let expirySeconds: number = this.exp - moment().unix();
    if (expirySeconds < 0) {
      return -1;
    }
    return expirySeconds;
  }

}

export class CasiInvalidTokenError extends Error { }
CasiInvalidTokenError.prototype.name = "CasiInvalidTokenError";

export const USER_ROLES = {
  SUPER_USER: "Superuser",
  ADMIN: "Administrator",
  GENERAL: "General",
  READ_ONLY: "ReadOnly",
  BASIC: "User"
};

export class User implements IClaimSub {
  static create(args: any) {
    // console.log(`User:create: `, args);
    const {
      userId, roles,
      admin, superuser, firstName, lastName,
      email, acceptedTermsVersion, sessionId,
      researchConsent, phone
    } = args;
    return new User(
      userId, roles,
      admin, superuser, firstName, lastName,
      email, acceptedTermsVersion, researchConsent, sessionId,
      phone
    );
  };
  static createFromSub(args: IClaimSub) {
    // console.log(`User:createFromSub: `, args);
    const {
      userId, roles,
      admin, superuser, firstName, lastName,
      email, acceptedTermsVersion, sessionId,
      researchConsent, phone
    } = args;
    return new User(
      userId, roles,
      admin, superuser, firstName, lastName,
      email, acceptedTermsVersion, researchConsent, sessionId,
      phone
    );
  };

  constructor(
    public userId: number,
    public roles: any[],
    public admin: boolean,
    public superuser: boolean,
    public firstName: string,
    public lastName: string,
    public email: string,
    public acceptedTermsVersion: number,
    public researchConsent?: boolean | undefined,
    public sessionId?: any | undefined,
    public phone?: string) { }

  get fullName() {
    return `${this.firstName} ${this.lastName}`;
  }
  // get userId() {
  //   return this.userId;
  // }

  get isAdmin() {
    return this.hasRoles(USER_ROLES.ADMIN);
  }

  get isSuperUser() {
    return this.hasRoles(USER_ROLES.SUPER_USER);
  }

  get isBasic() {
    return this.hasRoles(USER_ROLES.BASIC);
  }

  hasRoles(role: string): boolean {
    if (this.roles) {
      return this.roles.map(r => r.name).indexOf(role) >= 0;
    }
    return false;
  }

  // forSubmit(): any {
  //   return {
  //     first_name: this.firstName,
  //     last_name: this.lastName,
  //     email: this.email,
  //     uuid: this.uuid
  //   };
  // }
};

